import isEmpty from './isEmpty';

export default (model: any) => {
  if (!model) return false;
  if (Array.isArray(model) && !model.length) return false;
  if (isEmpty(model)) return false;
  return true;
};
